import { Badge } from '@react-spectrum/s2';

import { PROCESS_STATUS_CONFIG } from './processConstants';

type BadgeVariant =
	| 'neutral'
	| 'positive'
	| 'notice'
	| 'negative'
	| 'informative';

function formatStatusLabel(status: string): string {
	if (!status) return 'Unknown';
	return status.charAt(0).toUpperCase() + status.slice(1);
}

export const ProcessStatusBadge = ({ status }: { status: string }) => {
	const config = (
		PROCESS_STATUS_CONFIG as Record<
			string,
			{ label: string; variant: BadgeVariant } | undefined
		>
	)[status];
	const variant = config?.variant ?? 'neutral';

	return (
		<Badge variant={variant} fillStyle="subtle" size="S">
			{config?.label ?? formatStatusLabel(status)}
		</Badge>
	);
};
